import api, { ApiResponse } from "../api";
import axios, { CancelTokenSource } from "axios";

import { CompanyInfoModel, CompanySummaryModel, RevenueResponseModel } from "./models";

export const REQUEST_ID: {
  [key: string]: string;
} = {
  GET_COMPANY_INFO: "get_company_info",
  GET_COMPANY_SUMMARY: "get_company_summary",
  GET_REVENUE: "get_revenue",
};

class AccountDetailsService {
  private source: {
    [key: string]: CancelTokenSource;
  };

  private static instance: AccountDetailsService;

  private constructor() {
    this.source = {};
  };

  static getInstance(): AccountDetailsService {
    if (!AccountDetailsService.instance) {
      AccountDetailsService.instance = new AccountDetailsService();
    }
    return AccountDetailsService.instance;
  };

  public getAccountDetailsCompanyInfo = async (
    accountNumber: string
  ): Promise<ApiResponse<CompanyInfoModel>> => {
    this.source[REQUEST_ID.GET_COMPANY_INFO] && this.source[REQUEST_ID.GET_COMPANY_INFO].cancel();
    this.source[REQUEST_ID.GET_COMPANY_INFO] = axios.CancelToken.source();

    return await api.get(
      `/accounts/customer/${accountNumber}`,
      { cancelToken: this.source[REQUEST_ID.GET_COMPANY_INFO].token },
    );
  };

  public getAccountDetailsCompanySummary = async (
    accountNumber: string
  ): Promise<ApiResponse<CompanySummaryModel>> => {
    this.source[REQUEST_ID.GET_COMPANY_SUMMARY] && this.source[REQUEST_ID.GET_COMPANY_SUMMARY].cancel();
    this.source[REQUEST_ID.GET_COMPANY_SUMMARY] = axios.CancelToken.source();
    return await api.get(`/accounts/summary/${accountNumber}`, { cancelToken: this.source[REQUEST_ID.GET_COMPANY_SUMMARY].token });    
  };

  public getAccountDetailsRevenue = async (
    accountNumber: string
  ): Promise<ApiResponse<RevenueResponseModel>> => {
    this.source[REQUEST_ID.GET_REVENUE] && this.source[REQUEST_ID.GET_REVENUE].cancel();
    this.source[REQUEST_ID.GET_REVENUE] = axios.CancelToken.source();
    return await api.get(`/accounts/revenue/${accountNumber}`, { cancelToken: this.source[REQUEST_ID.GET_REVENUE].token });    
  };
};

export default AccountDetailsService;